<template>
    <vue-custom-scrollbar id="projects-lite" class="workspace-module-container" @ps-y-reach-end="scrollReachEnd">
        <div id="projects-lite-label">Выберите дом и начните подбор дизайна прямо сейчас
        </div>

            <div id="projects-lite-items-container" class="projects-grid-nine">
                <div v-for="(project) in projectList" class="project-card-lite" :title="project.data_json.name"
                     v-on:click="openProject(project)"
                     v-bind:class="{'active-project': projectSelected === project.guid}">
                    <TitlePhotoForProject :dataProject="project.data_json"/>
                </div>
            </div>

        <div v-if="waitingResponseToProjectsRequest" class="ap-loader-grid">
            <SpinnerTwo/>
            <div class="ap-loader-text">
                Идет загрузка проектов ...
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import {modalMethods, urlForFileStorage, urlForStaticVue} from "../../common";
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import SpinnerTwo from "../../SpinnerTwo";
    import SVGStepsProjects from "../../SVG/SVGStepsProjects";
    import TitlePhotoForProject from "../TitlePhotoForProject";

    export default {
        name: "WorkspaceLiteProjects",
        components: {
            TitlePhotoForProject,
          SVGStepsProjects,
            vueCustomScrollbar,
            SpinnerTwo
        },
        mixins: [urlForFileStorage, urlForStaticVue, modalMethods],
        computed: {
            projectList() {
                return this.$store.getters["UI/loadedProjectList/UPLOADED_PROJECTS"];
            },
            projectSelected() {
                return this.$store.state.route.params.projectUUID;
            },
            waitingResponseToProjectsRequest() {
                return this.$store.state.UI.loadedProjectList.waitingResponseToProjectsRequest;
            }
        },
        methods: {
            firstPropFromObject(inputObject){
                for (let prop in inputObject) {
                    return prop;
                }
            },
            selectProject(project) {
                const projectGUID = project.guid;
                const photoID = this.firstPropFromObject(project.data_json.photoList);
                if (!photoID) {
                    alert('У этого проекта нет фотографий!');
                    return;
                }
                this.$router.replace({
                    name: "liteSelectProjects",
                    params: {projectUUID: projectGUID, photoID: photoID}
                }).catch((err) => {
                });
            },
            openProject(project) {
                const projectGUID = project.guid;
                const photoID = this.firstPropFromObject(project.data_json.photoList);
                if (!photoID) {
                    alert('У этого проекта нет фотографий!');
                    return;
                }
                this.$router.push({
                    name: "liteDesignList",
                    params: {projectUUID: projectGUID, photoID: photoID}
                }).catch((err) => {
                });
            },
            // titleImageProject(photoList) {
            //     for (let idPhoto in photoList) {
            //         return this.urlForFileStorage(photoList[idPhoto].src);
            //     }
            //     return this.urlForStatic('img/No_Picture.jpg');
            // },
            scrollReachEnd() {
                this.$store.dispatch('UI/loadedProjectList/GET_PROJECTS_LITE');
            },
        },
        mounted() {
            this.$store.dispatch('UI/loadedProjectList/GET_PROJECTS_LITE');
        },
        destroyed() {
            this.$store.dispatch('projectList/DELETE_ALL_PROJECTS_EXCEPT_ACTIVE');
            this.$store.commit('UI/loadedProjectList/CLEAR_UPLOADED_PROJECTS');
        }
    }
</script>

<style scoped>
    #projects-lite {
        padding: 20px 100px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        /*background-color: #f2f2f2;*/
        /*background-color: #f9f9f9;*/
        background-color: #f6f6f6;
    }

    #projects-lite-label {
        font-size: 32px;
        font-weight: bold;
        color: #292929;
        padding: 10px;
        font-family: 'Red Ring', sans-serif;
        margin-bottom: 20px;
        text-align: center;
    }

    .projects-lite-text-container {
        color: #303030;
        padding: 10px;
    }

    .custom-link {
      cursor: pointer;
    }

    #svg-request-custom {
      width: 35px;
      height: 35px;
      position: relative;
      top: 4px;
    }

    .projects-grid-nine {
        /*display: grid;*/
        display: flex;
        flex-wrap: wrap;
        padding-top: 15px;
        /*grid-template-columns: 32% 32% 32%;*/
        /*grid-template-rows: 32% 32% 32%;*/
        /*grid-auto-flow: row dense;*/
        /*grid-template-columns: repeat(3, minmax(0, 1fr));*/
        /*grid-column-gap: 15px;*/
        /*grid-row-gap: 15px;*/
        max-width: 1400px;
        width: max-content;
        margin: 0 auto;
        /*justify-content: flex-start;*/
    }

    @media screen and (max-width: 1600px) {
        .projects-grid-nine {
            width: auto;
        }
    }

    .project-card-lite {
        /*max-height: calc((95vh - 202px) / 3);*/
        /*height: 200px;*/
        /*width: 300px;*/
        position: relative;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 30px;
        cursor: pointer;
        user-select: none;
        transition: box-shadow 0.3s ease;
        border-radius: 4px;
        width: 100%;
        /*aspect-ratio: 4 / 3;*/
        /*border: 1px solid #efefef;*/
    }

    /*@media (min-width: 768px) and (orientation: landscape) {*/
    /*    .project-card-lite {*/
    /*        width: 33.33333333%;*/
    /*    }*/
    /*}*/
    @media (max-width: 480px){
        .project-card-lite {
            width: 100%;
        }
    }


        .project-card-lite {
            /*max-height: calc((95vh - 202px) / 3);*/
            /*height: 200px;*/
            /*width: 300px;*/
            position: relative;
            padding-left: 15px;
            padding-right: 15px;
            margin-bottom: 30px;
            cursor: pointer;
            user-select: none;
            transition: box-shadow 0.3s ease;
            border-radius: 4px;
            width: 100%;
            /*aspect-ratio: 4 / 3;*/
            /*border: 1px solid #efefef;*/
        }
    @media (min-width: 800px) {
        .project-card-lite {
            width: 45%;
        }
    }
    @media (min-width: 1000px) {
        .project-card-lite {
            width: calc(100% / 3 - 30px);
        }
    }
      /*@media (min-width: 992px) {*/
      /*  .project-card-lite {*/
      /*    width: 33.33333333%;*/
      /*  }*/
      /*}*/
    /*@media (min-width: 768px) {*/
    /*  .project-card-lite {*/
    /*    width: 25%;*/
    /*  }*/
    /*}*/

    #projects-lite-items-container {
      /*max-width: 960px;*/
    }


    .project-card-lite:active {

    }
</style>
